// extracted by mini-css-extract-plugin
export default {"bgImage":"styles_bgImage__L5C8V"};